var _regeneratorRuntime = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createClass.js").default;

!function webpackUniversalModuleDefinition(e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports["@wordpress/token-list"] = r() : (e.wp = e.wp || {}, e.wp.tokenList = r());
}(self, function () {
  return function () {
    "use strict";

    var e = {
      793: function _(e) {
        e.exports = require("lodash");
      }
    },
        r = {};

    function __webpack_require__(t) {
      var s = r[t];
      if (void 0 !== s) return s.exports;
      var i = r[t] = {
        exports: {}
      };
      return e[t](i, i.exports, __webpack_require__), i.exports;
    }

    var t = {};
    return function () {
      var e = t;
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = void 0;

      var r = __webpack_require__(793);

      var TokenList = /*#__PURE__*/function (_Symbol$iterator) {
        function TokenList() {
          _classCallCheck(this, TokenList);

          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          this.value = e, this._currentValue, this._valueAsArray;
        }

        _createClass(TokenList, [{
          key: "entries",
          value: function entries() {
            var _this$_valueAsArray;

            return (_this$_valueAsArray = this._valueAsArray).entries.apply(_this$_valueAsArray, arguments);
          }
        }, {
          key: "forEach",
          value: function forEach() {
            var _this$_valueAsArray2;

            return (_this$_valueAsArray2 = this._valueAsArray).forEach.apply(_this$_valueAsArray2, arguments);
          }
        }, {
          key: "keys",
          value: function keys() {
            var _this$_valueAsArray3;

            return (_this$_valueAsArray3 = this._valueAsArray).keys.apply(_this$_valueAsArray3, arguments);
          }
        }, {
          key: "values",
          value: function values() {
            var _this$_valueAsArray4;

            return (_this$_valueAsArray4 = this._valueAsArray).values.apply(_this$_valueAsArray4, arguments);
          }
        }, {
          key: "value",
          get: function get() {
            return this._currentValue;
          },
          set: function set(e) {
            e = String(e), this._valueAsArray = (0, r.uniq)((0, r.compact)(e.split(/\s+/g))), this._currentValue = this._valueAsArray.join(" ");
          }
        }, {
          key: "length",
          get: function get() {
            return this._valueAsArray.length;
          }
        }, {
          key: "toString",
          value: function toString() {
            return this.value;
          }
        }, {
          key: _Symbol$iterator,
          value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
            return _regeneratorRuntime.wrap(function value$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    return _context.delegateYield(this._valueAsArray, "t0", 1);

                  case 1:
                    return _context.abrupt("return", _context.t0);

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, value, this);
          })
        }, {
          key: "item",
          value: function item(e) {
            return this._valueAsArray[e];
          }
        }, {
          key: "contains",
          value: function contains(e) {
            return -1 !== this._valueAsArray.indexOf(e);
          }
        }, {
          key: "add",
          value: function add() {
            for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++) {
              r[t] = arguments[t];
            }

            this.value += " " + r.join(" ");
          }
        }, {
          key: "remove",
          value: function remove() {
            for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++) {
              t[s] = arguments[s];
            }

            this.value = (0, r.without).apply(void 0, [this._valueAsArray].concat(t)).join(" ");
          }
        }, {
          key: "toggle",
          value: function toggle(e, r) {
            return void 0 === r && (r = !this.contains(e)), r ? this.add(e) : this.remove(e), r;
          }
        }, {
          key: "replace",
          value: function replace(e, r) {
            return !!this.contains(e) && (this.remove(e), this.add(r), !0);
          }
        }, {
          key: "supports",
          value: function supports() {
            return !0;
          }
        }]);

        return TokenList;
      }(Symbol.iterator);

      e.default = TokenList;
    }(), t;
  }();
});